<template lang="pug">
	.container-fluid
		.row
			.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
				.card
					.card-header.bg-info.text-white
						.row
							.col
								span.fa.fa-tasks.mr-2
								span Pendientes
							.col.text-right
								button.btn.btn-sm.btn-warning(
									@click="setNueva"
									style="position: absolute;display: block;right: 10px; top: -2px;"
								)
									span.fa.fa-plus.mr-2
									span Nueva
					Tarea(
						v-for="tarea of tareasPendientes"
						:key="tarea.TareaID"
						:tarea="tarea"
						@ver="verTarea(tarea)"
					)
			.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
				.card
					.card-header.bg-danger.text-white
						span.fa.fa-check-square.mr-2
						span Realizados
					Tarea(
						v-for="tarea of tareasRealizadas"
						:key="tarea.TareaID"
						:tarea="tarea"
						@ver="verTarea(tarea)"
					)
			.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
				.card
					.card-header.bg-success.text-white
						span.fa.fa-flag-checkered.mr-2
						span Publicado
					Tarea(
						v-for="tarea of tareasFinalizadas"
						:key="tarea.TareaID"
						:tarea="tarea"
						@ver="verTarea(tarea)"
					)
		Editor(
			v-if="EditarID"
			:TareaID="EditarID"
			@actualizar="buscar()"
			@cerrar="EditarID = null"
		)

		TareaDetalle(
			v-if="TareaID"
			:TareaID="TareaID"
			@cerrar="$router.push('/main/produccion-audiovisual')"
			@actualizar="buscar()"
			@editar="EditarID = $event"
		)
</template>

<script>
import Editor from '../nueva/nueva.component'
import TareaDetalle from '../detalles/tareaDetalle.component'
import Tarea from './tarea.component'
import axios from 'axios'
export default {
	components: {
		Tarea,
		TareaDetalle,
		Editor
	},
	data () {
		return {
			tareas: [],
			intervalo: null,
			TareaID: null,
			EditarID: null
		}
	},
	created () {
		this.buscar()
		this.intervalo = window.setInterval(() => {
			this.buscar()
		}, 10000)

		if (this.$route.params.TareaID) {
			this.TareaID = this.$route.params.TareaID
		}
	},
	watch: {
		'$route.params': function (newVal) {
			if (newVal.TareaID) {
				this.TareaID = newVal.TareaID
			} else {
				this.TareaID = null
			}
		}
	},
	beforeDestroy () {
		window.clearInterval(this.intervalo)
	},
	computed: {
		tareasPendientes () {
			return this.tareas.filter(t => (!t.FechaFinalizada && !t.GaleriaID))
		},
		tareasRealizadas () {
			return this.tareas.filter(t => (!t.FechaFinalizada && t.GaleriaID))
		},
		tareasFinalizadas () {
			return this.tareas.filter(t => (t.FechaFinalizada && t.GaleriaID))
		}
	},
	methods: {
		setNueva () {
			this.EditarID = 'nueva'
		},
		buscar () {
			axios.get('produccion-audiovisual/php/api/getTareas.php')
				.then(res => {
					this.tareas = res.data
				})
				.catch(e => {
					console.error(e)
				})
		},
		verTarea (tarea) {
			this.$router.push('/main/produccion-audiovisual/tarea/' + tarea.TareaID)
			// this.TareaID = tarea.TareaID
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion-audiovisual/vue/components/overview/overview.component.vue